import * as styles from "./SliderValue.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Slider as BaseSlider } from "@base-ui/react/slider";

import type { SliderValueProps } from "./Slider.types";

export function SliderValue({
  className,
  ...props
}: SliderValueProps): JSX.Element {
  return (
    <BaseSlider.Value
      data-slot="slider-value"
      className={clsx(styles.value, className)}
      {...props}
    />
  );
}
